import type { ReactNode } from 'react';


import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import IconButton from 'components/partials/button/icon-button';

import Icons from 'assets/icons';

import {
  MARK_PANEL_CLOSE_ARIA_LABEL,
  MARK_PANEL_TITLE,
} from '../mark-panel.constants';

import MarkEmblem from './mark-emblem';

export interface MarkPanelDrawerProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

const MarkPanelDrawer = ({
  title,
  onClose,
  children,
  footer,
}: MarkPanelDrawerProps) => (
  <Box
    component="aside"
    aria-label={MARK_PANEL_TITLE}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '24rem',
      borderLeftWidth: '1px',
      borderColor: 'tokens.navy.200',
      bgcolor: 'common.white',
    }}
  >
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 1,
        borderBottomWidth: '1px',
        borderColor: 'tokens.navy.100',
        px: 2.5,
        py: 1.5,
      }}
    >
      <MarkEmblem className="size-6 shrink-0" />

      <span className="w-[200px] truncate text-lg font-bold text-navy-800">
        {title}
      </span>

      <IconButton
        variant="reserve-text"
        size="xs"
        icon={<Icons.Close aria-hidden="true" />}
        aria-label={MARK_PANEL_CLOSE_ARIA_LABEL}
        onClick={onClose}
        className="ml-auto"
      />
    </Stack>

    <div className="scrollbar-thin flex min-h-0 flex-1 flex-col gap-5 overflow-x-hidden overflow-y-auto px-5 py-3">
      {children}
    </div>

    {footer && (
      <Stack
        direction="row"
        sx={{
          minHeight: '84px',
          alignItems: 'center',
          borderTopWidth: '1px',
          borderColor: 'tokens.navy.200',
          px: 2.5,
          py: 2,
        }}
      >
        {footer}
      </Stack>
    )}
  </Box>
);

export default MarkPanelDrawer;
